<template>
  <section>

	<edit-identifiants
		v-if="displayEditIdentifiants"
		:row_en="selectedEnduser"
		class="m-auto w-100"
		@closeEditIdentifiants="displayEditId()"
	/>

	<!-- BOXES LOOP -->	
	<div v-for="(box, indexBox) in getEndusersWithBoxes" :key="indexBox">

		<h3>
			Kit Emotivi / {{box.en_fullname}}
		</h3>

		<!-- BOX CONTAINER -->
		

		<div class="d-flex flex-row w-100 mb-2"> 
			<h4 class="flex-grow-1 mb-0">
				Informations générales
			</h4>
		</div>
		<div class="alert alert-light">
			Commandée le : {{$moment(box.createdAt).format("DD/MM/YYYY [à] HH:mm")}}<br />
			Version logiciel : {{box.bo_id.bo_hardwareinfo.appemotivi_version}}<br />
			Adresse MAC Ethernet : {{box.bo_id.bo_hardwareinfo.ethernet_mac_address}}<br />
			Adresse MAC WIFI : {{box.bo_id.bo_hardwareinfo.wifi_mac_address}}
		</div>

		<div class="d-flex flex-row w-100 mb-2"> 
			<h4 class="flex-grow-1 mb-0">
				Informations de connexion
			</h4>
			<button
				v-if="box.bo_id"
				class="btn btn-sm btn-primary"
				type="button"
				@click="displayEditId(box)"
			>
				Modifier
			</button>
		</div>
		<div class="alert alert-light">
			identifiant : {{ box.en_webapp_login }}<br />
			mot de passe : {{ box.en_webapp_password }}<br />
			code administrateur : {{ box.en_admincode }}<br />
			<span v-if="box.bo_id">
				application Emotivi : <a @click="launchWebapp(box)" class="link">se connecter</a>
			</span>
		</div>
	</div>

  </section>
</template>

<script>
import boxOptions from "./BoxOptions.vue";
import editIdentifiants from "./EditIdentifiants.vue";
export default {
  components: { boxOptions, editIdentifiants },
  name: "privatebox",
  data() {
    return {
      dialogErrTxt: "",
      dialogOkTxt: "",
      row_co: {},
      endusers: [],
      parcels: [],
      depositNotPaid: false,
      displayBoxOptions: false,
      selectedEnduser: null,
      displayEditIdentifiants: false,
    };
  },
  async mounted() {
    // efface les données de paiement !!!
    this.$store.commit("set_co_webaccesstoken_temp", "");
  },
  computed: {
    getEndusersWithBoxes() {
      return this.$store.state.user.endusers &&
        Array.isArray(this.$store.state.user.endusers) &&
        this.$store.state.user.endusers.length
        ? this.$store.state.user.endusers.filter((enduser) => {
            return enduser.bo_id;
          })
        : [];
    },
  },

  methods: {
    launchWebapp(row_en) {
      window.open(
        this.$config.webapp_url +
          "/#/autosignin/" +
          row_en.en_accesstoken_fromwebapp,
        "_blank"
      );
    },
    configureBox(row_en) {
      window.open(
        this.$config.config_url +
          "/#/login/" +
          row_en.en_accesstoken_fromconfig,
        "_blank"
      );
    },


    redemBox(row_en) {
      this.$axios.get(
        this.$config.server_url + "/web/2.0/reboot/" + row_en.en_id
      );
    },
    displayOptions(row_en) {
      if (row_en) this.selectedEnduser = row_en;

      this.displayBoxOptions = !this.displayBoxOptions;
    },
    displayEditId(row_en) {
      if (row_en) this.selectedEnduser = row_en;
      this.displayEditIdentifiants = !this.displayEditIdentifiants;
    },
    /**
     * isBoxCompatible - check if the current box version is compatible with new options
     * @param {Object} row_en
     * @returns {Boolean}
     */
    isBoxCompatible(row_en, withWhat) {
      try {
        return (
          row_en.bo_id.bo_config_options &&
          row_en.bo_id.bo_config_options.hasOwnProperty(withWhat)
        );
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.webapplogindiv-enter-active,
.webapplogindiv-leave-active {
  transition: height 0s;
}
.webapplogindiv-enter, .webapplogindiv-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}
section {
  padding-bottom: 50px;
  // padding-top: 40px;
}
table {
  td {
    border: none;
    padding-left: 0;
  }
  th {
    padding-left: 7px;
  }
}
.reverseArrow {
  transform: rotate(180deg);
}
.link {
  color: blue;
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}
</style>
